import React, { Component } from 'react'
import { Email, Info, Name, Username } from './InfoBlockComponents'
import countUsers from '../../../../../helpers/users/manageUsers/countUsers';
import { Row, Col } from 'reactstrap'

export default class InfoBlockC extends Component{
  render(){
    let {
      fullName,
      username,
      email,
      sfid,
      created,
      lastModified,
      lastLogin,
      loginCount,
      validated,
      name,
      role,
      students,
      teachers,
      state,
      period, } = this.props.record 


      let {history ,record, recordType} = this.props
      let studentCount, teacherCount
      if (created) {
        created = (new Date(created)).toLocaleDateString()
      }
      if (lastModified) {
        lastModified = (new Date(lastModified)).toLocaleDateString()
      }
      if (lastLogin) {
        lastLogin = (new Date(lastLogin)).toLocaleDateString()
      }
      if (students) {
        studentCount = countUsers(students)
      }
      if (teachers) {
        teacherCount = countUsers(teachers)
      }
   

    return(
      <Col xs="12" md='12' className='info-block'>

      <Row>
        <Col md="4">
        {fullName ? <Name>{fullName}</Name> : null}
          {name && <Name>{name}</Name>}
        </Col>
        <Col md="4">
        {students && <Info label='Students'>{studentCount}</Info>}
        </Col>
        <Col md="4">
        {!validated && role ? <Info label='Registration'>Incomplete</Info> : null}
          {validated && role ? <Info label='Registration'>Complete</Info> : null}
        </Col>
      </Row>
     
      <Row className="mt-2">
       <Col md="4">
       {period && <Info label='Period'>{period}</Info>}
        </Col>
        <Col md="4">
        </Col>
        <Col md="4">
        </Col>
      </Row>
  
        </Col>
    )
  }
}



// {content}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/InfoBlockC.js